import Schema, { optional, array } from 'AppReact/schema';
import header from '../dataTableHeader/internalState';

const cell = { values: array('string'), keys: array('string'), component: optional('function') };

export default {
  header: header.content,
  orderBy: header.orderBy,
  orderDirection: header.orderDirection,
  rows: Schema(cell, 'array', { defaultValue: [] }),
  pageSize: Schema('integer', 'primitive', { defaultValue: 15 }),
  pageNumber: Schema('integer', 'primitive', { defaultValue: 0 }),
  total: Schema('integer', 'primitive', { defaultValue: 0 }),
  clickable: Schema('boolean', 'primitive-nullable', { defaultValue: false })
};
